/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Zone_ThresholdInputs */

const en_ui_zone_threshold = /** @type {(inputs: Ui_Zone_ThresholdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Threshold`)
};

const de_ui_zone_threshold = /** @type {(inputs: Ui_Zone_ThresholdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schwelle`)
};

/**
* | output |
* | --- |
* | "Threshold" |
*
* @param {Ui_Zone_ThresholdInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_zone_threshold = /** @type {((inputs?: Ui_Zone_ThresholdInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Zone_ThresholdInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_zone_threshold(inputs)
	return de_ui_zone_threshold(inputs)
});